export const SET_GRESTORE = 'SET_GRESTORE';
export const SET_GRESET = 'SET_GRESET';
export const SET_GCALENDAR = 'SET_GCALENDAR';
export const SET_GTICKECTNUM = 'SET_GTICKECTNUM';
export const SET_GSESSION = 'SET_GSESSION';
export const SET_GSESSIONPICKED = 'SET_GSESSIONPICKED';
export const SET_GTOTALAMOUNT = 'SET_GTOTALAMOUNT';
export const SET_GDETAIL = 'SET_GDETAIL';
export const SET_GTEMPCALENDARDATA = 'SET_GTEMPCALENDARDATA';
export const SET_GCALENDARREF = 'SET_GCALENDARREF';
export const SET_ISGDSDETAILLOADING = 'SET_ISGDSDETAILLOADING';
export const SET_GDSDETAILFETCHFAIL = 'SET_GDSDETAILFETCHFAIL';
export const SET_ISGDSSESSIONLOADING = 'SET_ISGDSSESSIONLOADING';
export const SET_GDSSESSIONFETCHFAIL = 'SET_GDSSESSIONFETCHFAIL';
export const SET_GNOWLIST = 'SET_GNOWLIST';
export const SET_GNOWLISTDATA = 'SET_GNOWLISTDATA';
export const SET_GCALENDARERR = 'SET_GCALENDARERR';
export const SET_GSESSIONERR = 'SET_GSESSIONERR';
export const SET_GTICKETERR = 'SET_GTICKETERR';
export const SET_GSCROLLTO = 'SET_GSCROLLTO';
export const SET_GSUBMITWATCHER = 'SET_GSUBMITWATCHER';
export const SET_ISGSUBMITSUCCESS = 'SET_ISGSUBMITSUCCESS';
